'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = computors;
var _topojsonClient = require('topojson-client');
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _d3Geo = require('d3-geo');
var d3Geo = _interopRequireWildcard(_d3Geo);
var _d3GeoProjection = require('d3-geo-projection');
var d3GeoProjections = _interopRequireWildcard(_d3GeoProjection);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _constants = require('../utils/constants');
var _computors = require('../utils/computors');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var projectionsCollection = (0, _extends3.default)({}, d3Geo, d3GeoProjections);
function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    areas: function areas(data) {
      return (0, _topojsonClient.feature)(data, target.accessors.areas(data));
    },
    dataBbox: R.pipe(_topojsonClient.bbox, function (_ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 4),
        xA = _ref2[0],
        yA = _ref2[1],
        xB = _ref2[2],
        yB = _ref2[3];
      return [[xA, xB], [yA, yB]];
    }, R.map(R.sortBy(R.identity)), function (_ref3) {
      var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
        _ref4$ = (0, _slicedToArray3.default)(_ref4[0], 2),
        xMin = _ref4$[0],
        xMax = _ref4$[1],
        _ref4$2 = (0, _slicedToArray3.default)(_ref4[1], 2),
        yMin = _ref4$2[0],
        yMax = _ref4$2[1];
      return [xMin < -180 || xMax > 180 ? [-180, 180] : [xMin, xMax], yMin < -90 || yMax > 90 ? [-90, 90] : [yMin, yMax]];
    }),
    dataBboxCoordinates: function dataBboxCoordinates(data, projection) {
      var _target$computors$dat = target.computors.dataBbox(data),
        _target$computors$dat2 = (0, _slicedToArray3.default)(_target$computors$dat, 2),
        _target$computors$dat3 = (0, _slicedToArray3.default)(_target$computors$dat2[0], 2),
        xMin = _target$computors$dat3[0],
        xMax = _target$computors$dat3[1],
        _target$computors$dat4 = (0, _slicedToArray3.default)(_target$computors$dat2[1], 2),
        yMin = _target$computors$dat4[0],
        yMax = _target$computors$dat4[1];
      var geometry = {
        type: 'Feature',
        geometry: {
          type: 'MultiLineString',
          coordinates: [[[xMax, yMin], [xMax, yMax]], [[xMin, yMax], [xMin, yMin]], [[(xMin + xMax) / 2, yMin], [(xMin + xMax) / 2, yMax]]]
        }
      };
      return _d2.default.geo.path().projection(projection).bounds(geometry);
    },
    rawProjection: function rawProjection(options) {
      var projectionKey = target.accessors.projection(options);
      return R.has(projectionKey, projectionsCollection) ? projectionsCollection['' + projectionKey] : projectionsCollection['' + _constants.DEFAULT_PROJECTION];
    },
    projection: function projection(options, data) {
      var rawProjection = target.computors.rawProjection(options);
      var width = target.accessors.width(options);
      var height = target.accessors.height(options);
      var innerPadding = target.accessors.innerPadding(options);
      var extent = [[innerPadding.left, innerPadding.top], [width - innerPadding.right, height - innerPadding.bottom]];
      var optionsScale = target.accessors.scale(options);
      if (R.isNil(optionsScale)) {
        return rawProjection().fitExtent(extent, target.computors.areas(data));
      }
      var projection = rawProjection().scale(optionsScale).translate([width / 2, height / 2]);
      var _target$computors$dat5 = target.computors.dataBboxCoordinates(data, projection),
        _target$computors$dat6 = (0, _slicedToArray3.default)(_target$computors$dat5, 2),
        _target$computors$dat7 = (0, _slicedToArray3.default)(_target$computors$dat6[0], 2),
        left = _target$computors$dat7[0],
        top = _target$computors$dat7[1],
        _target$computors$dat8 = (0, _slicedToArray3.default)(_target$computors$dat6[1], 2),
        right = _target$computors$dat8[0],
        bottom = _target$computors$dat8[1];
      var horizontalOffset = (0, _computors.computeOffset)(width, left, right);
      var verticalOffset = (0, _computors.computeOffset)(height, top, bottom);
      return rawProjection().scale(optionsScale).translate([width / 2 + horizontalOffset, height / 2 + verticalOffset]).clipExtent(extent);
    },
    interiorBoundaries: function interiorBoundaries(data) {
      return (0, _topojsonClient.mesh)(data, target.accessors.areas(data), function (a, b) {
        return a !== b;
      });
    },
    exteriorBoundaries: function exteriorBoundaries(data) {
      return (0, _topojsonClient.mesh)(data, target.accessors.areas(data), function (a, b) {
        return a === b;
      });
    },
    tooltipLayout: function tooltipLayout(serie, datum, color) {
      var style = '\n      font-size: 10px;\n      font-family: sans-serif;\n      color: ' + color + ';\n      padding: 5px;\n      border: 1px solid ' + color + ';\n      background: white;\n      opacity: .8;\n    ';
      return '<div style="' + style + '">' + R.pathOr(null, ['properties', 'label'], datum) + '<br />' + R.pathOr(null, ['properties', 'value'], datum) + '</div>';
    }
  });
}